{
    "$id": "https://github.com/LIT-Protocol/accs-schemas/blob/main/src/generated/LPACC_EVM_BASIC.json",
    "title": "LPACC_EVM_BASIC",
    "description": "",
    "type": "object",
    "properties": {
        "conditionType": {
            "type": "string"
        },
        "contractAddress": {
            "type": "string"
        },
        "chain": {
            "enum": [
                "ethereum",
                "polygon",
                "fantom",
                "xdai",
                "bsc",
                "arbitrum",
                "avalanche",
                "fuji",
                "harmony",
                "kovan",
                "mumbai",
                "goerli",
                "ropsten",
                "rinkeby",
                "cronos",
                "optimism",
                "celo",
                "aurora",
                "eluvio",
                "alfajores",
                "xdc",
                "evmos",
                "evmosTestnet"
            ]
        },
        "standardContractType": {
            "enum": [
                "",
                "ERC20",
                "ERC721",
                "ERC721MetadataName",
                "ERC1155",
                "CASK",
                "Creaton",
                "POAP",
                "timestamp",
                "MolochDAOv2.1",
                "ProofOfHumanity",
                "SIWE",
                "PKPPermissions"
            ]
        },
        "method": {
            "type": "string"
        },
        "parameters": {
            "type": "array",
            "items": {
                "type": "string"
            }
        },
        "returnValueTest": {
            "type": "object",
            "properties": {
                "comparator": {
                    "enum": ["contains", "=", ">", ">=", "<", "<="]
                },
                "value": {
                    "type": "string"
                }
            },
            "required": ["comparator", "value"],
            "additionalProperties": false
        }
    },
    "required": [
        "contractAddress",
        "chain",
        "standardContractType",
        "method",
        "parameters",
        "returnValueTest"
    ],
    "additionalProperties": false
}
